import { API_REQUEST_DEFAULTS } from "../constants/apiEndpoints";

export const fetchWithTimeout = async (
  url,
  options = {},
  timeoutMs = API_REQUEST_DEFAULTS.configurationTimeoutMs,
) => {
  const controller = new AbortController();
  const upstreamSignal = options.signal;
  const abortFromUpstream = () => controller.abort(upstreamSignal?.reason);
  if (upstreamSignal) {
    if (upstreamSignal.aborted) abortFromUpstream();
    else upstreamSignal.addEventListener("abort", abortFromUpstream, { once: true });
  }
  const timeout = globalThis.setTimeout(() => controller.abort(), timeoutMs);

  try {
    return await fetch(url, { ...options, signal: controller.signal });
  } catch (error) {
    if (error?.name === "AbortError" && !upstreamSignal?.aborted) {
      const timeoutError = new Error(
        "The questionnaire service took too long to respond. Please try again.",
      );
      timeoutError.code = "questionnaire_request_timeout";
      throw timeoutError;
    }
    throw error;
  } finally {
    globalThis.clearTimeout(timeout);
    upstreamSignal?.removeEventListener?.("abort", abortFromUpstream);
  }
};
